import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import Row from 'react-bootstrap/lib/Row';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Col from 'react-bootstrap/lib/Col';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import CurrencyConverter from '../../CurrencyConverter';
import { getCalculationDetails } from '../../../helpers/Pricing/getCalculationDetails.js';
import s from './Calendar.css';
import messages from '../../../locale/messages.js';
class BillDetails extends Component {
    static propTypes = {
        basePrice: PropTypes.number.isRequired,
        cleaningPrice: PropTypes.number,
        tax: PropTypes.number,
        currency: PropTypes.string.isRequired,
        monthlyDiscount: PropTypes.number,
        weeklyDiscount: PropTypes.number,
        startDate: PropTypes.object.isRequired,
        endDate: PropTypes.object.isRequired,
        serviceFees: PropTypes.shape({
            guest: PropTypes.shape({
                type: PropTypes.string.isRequired,
                value: PropTypes.number.isRequired,
                currency: PropTypes.string.isRequired
            }).isRequired
        }).isRequired,
        base: PropTypes.string.isRequired,
        rates: PropTypes.object.isRequired,
        formatMessage: PropTypes.any,
        specialPricing: PropTypes.array,
    };

    static defaultProps = {
        basePrice: 0, cleaningPrice: 0, tax: 0, monthlyDiscount: 0, weeklyDiscount: 0,
        startDate: null, endDate: null, specialPricing: [],
    }

    render() {
        const { tax, currency, endDate, serviceFees, base, rates, specialPricing, change, toCurrency } = this.props;
        const { startDate, basePrice, cleaningPrice, monthlyDiscount, weeklyDiscount } = this.props;
        const { formatMessage } = this.props.intl;
        const { guestServiceFee, hostServiceFee, priceForDays, isAverage, total, dayDifference } = getCalculationDetails({
            startDate, basePrice, cleaningPrice, monthlyDiscount, weeklyDiscount, formatMessage,
            serviceFees, specialPricing, toCurrency, tax, currency, endDate, base, rates
        });

        change("BookingForm", 'isHostServiceEligible', hostServiceFee > priceForDays ? true : false);
        if (isAverage) {
            change("BookingForm", 'averageBasePrice', isAverage);
        }

        return (
            <FormGroup className={s.noMargin}>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} className={'viewListingCalender'}>
                        <div className={cx('paymentDetailsFlex', s.billdetail)}>
                            <div className={'paymentDetailsFlexLeft'}>Comisión Eslipin</div>
                            <div className={'paymentDetailsFlexRight'}>
                                <CurrencyConverter amount={guestServiceFee} from={currency} />
                            </div>
                        </div>
                        <div className={cx('paymentDetailsFlex', s.billdetail)}>
                            <div className={'paymentDetailsFlexLeft'}>Otras Tarifas</div>
                            <div className={'paymentDetailsFlexRight'}>
                                <CurrencyConverter amount={cleaningPrice} from={currency} />
                            </div>
                        </div>
                        <div className={cx('paymentDetailsFlex', s.billdetail)}>
                            <div className={'paymentDetailsFlexLeft'}>Alojamiento ({dayDifference} {dayDifference > 1 ? 'noches' : 'noche'})</div>
                            <div className={'paymentDetailsFlexRight'}>
                                <CurrencyConverter amount={priceForDays} from={currency} />
                            </div>
                        </div>
                        <div className={cx('paymentDetailsFlex', s.billdetail, s.totalBorderTop)}>
                            <div className={cx(s.totalText, 'paymentDetailsFlexLeft')}>Total</div>
                            <div className={cx(s.totalText, 'paymentDetailsFlexRight')}>
                                <CurrencyConverter amount={total} from={currency} />
                            </div>
                        </div>
                        <div className={cx('comissionLabel')}>
                            <FormattedMessage {...messages.comisionEslipinNote} />
                        </div>
                    </Col>
                </Row>
            </FormGroup>
        );
    }
}

const mapState = (state) => ({
    specialPricing: state.viewListing.specialPricing,
    toCurrency: state.currency.to || state.currency.base,
});

const mapDispatch = {
    change
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(BillDetails)));